import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {AddSubAccountDialogComponent} from './components/add-sub-account-dialog/add-sub-account-dialog.component';
import {AddUserDialogComponent} from './components/add-user-dialog/add-user-dialog.component';
import {EditPackagesDialogComponent} from './components/edit-packages-dialog/edit-packages-dialog.component';
import {FirmSubAccountUsersGridHostComponent} from './components/sub-account-users-grid-host/sub-account-users-grid-host.component';
// @dynamic
export class FirmDynamicComponentHelper {
  static components: any;

  static create (): void {
  }

  public static init () {
    if (FirmDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['AddSubAccountDialogComponent'] = AddSubAccountDialogComponent;
    components['AddUserDialogComponent'] = AddUserDialogComponent;
    components['EditPackagesDialogComponent'] = EditPackagesDialogComponent;
    components['FirmSubAccountUsersGridHostComponent'] = FirmSubAccountUsersGridHostComponent;
    FirmDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static getComponentArray (): any[] {
    FirmDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(FirmDynamicComponentHelper.components).forEach(key => {
      componentArray.push(FirmDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }

  public static register(key: string, component: any) {
    FirmDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
